@if (error && !displayPasscodeDialog && !noWarrantyFound) {
  <main>
    <div class="authenticity-card text-center p-8">
      <p class="mb-4">{{ error }}</p>

      <button data-testid="digital-passport-retry" type="button" class="btn primary-btn" [disabled]="loading" (click)="initializeDigitalPassport()">
        {{ 'DIGITAL_PASSPORT.PASSCODE.BTN_RETRY' | translate }}
      </button>
    </div>
  </main>
}

@if (productInfo && !noWarrantyFound && !displayPasscodeDialog) {
  <main>
    <div class="authenticity-card fade-in">
      <div class="product-hero" id="productHero" [style.--bg-image]="'url(' + productInfo.productImageUrl + ')'" [class.no-image]="!productInfo.productImageUrl">
        <!-- Mock img -->
        <!-- <div class="product-hero" id="productHero" [style.--bg-image]="'url(https://www.demo.com/image/catalog/product/0NEW/2023/BR03-GMT-BLUE-UpDate/Produit-GMTBlue-Soldat.png)'"> -->
        <div class="product-hero-content">
          <h1 class="product-name" id="productName">{{ productInfo.productName }}</h1>
          <div class="authenticity-badge">
            <div class="checkmark">✓</div>
            {{ 'DIGITAL_PASSPORT.AUTHENTIC_PRODUCT'| translate }}
          </div>
        </div>
      </div>
      @if (headerText) {
        <div class="authenticity-description text-sm">
          <quill-view class="notice-rich-text"
            [content]="headerText" format="object"
            theme="snow"></quill-view>
        </div>
      }
      <div class="product-details">
        <div class="detail-group">
          <div class="detail-row">
            <span class="detail-label">{{ 'DIGITAL_PASSPORT.SERIAL_NUMBER'| translate }}</span>
            <span class="detail-value serial-highlight" id="serialNumber">{{ productInfo.serialNumber }}</span>
          </div>
          <div class="detail-row">
            <span class="detail-label">{{ 'DIGITAL_PASSPORT.SKU'| translate }}</span>
            <span class="detail-value" id="reference">{{ productInfo.sku }}</span>
          </div>
        </div>
        <div class="detail-row">
          <span class="detail-label">{{ 'DIGITAL_PASSPORT.PURCHASE_DATE' | translate }}</span>
          <span class="detail-value">{{ productInfo.purchaseDate | date: 'd MMMM, yyyy' }}</span>
        </div>
        <!-- Warranty List -->
        @for (warranty of warrantyList; track warranty; let i = $index) {
          <div class="warranty-section">
            <div class="warranty-header">
              {{ 'DIGITAL_PASSPORT.WARRANTY_INFORMATION' | translate }} #{{ i + 1 }}
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ 'DIGITAL_PASSPORT.WARRANTY_CODE' | translate }}</span>
              <span class="detail-value serial-highlight">{{ warranty.code }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ 'DIGITAL_PASSPORT.PURCHASE_DATE' | translate }}</span>
              <span class="detail-value">{{ warranty.activationDate | date: 'd MMMM, yyyy' }}</span>
            </div>
            <div class="detail-row">
              <span class="detail-label">{{ 'DIGITAL_PASSPORT.WARRANTY_EXPIRES' | translate }}</span>
              <span class="detail-value">{{ warranty.endDate | date: 'd MMMM, yyyy' }}</span>
            </div>
            <div class="warranty-status" [ngClass]="{'active': warranty.isActive, 'expired': !warranty.isActive}">
              {{ warranty.isActive ? ('DIGITAL_PASSPORT.ACTIVE_COVERAGE' | translate) : ('DIGITAL_PASSPORT.EXPIRED_COVERAGE' | translate) }}
            </div>
          </div>
        }
      </div>
      <div class="footer">
        @if (productInfo.ctaUrl) {
          <div class="flex items-center justify-center mb-4" id="cta-insurance-button">
            <a data-testid="cta-insurance-button" class="btn primary-btn" [href]="productInfo.ctaUrl" target="_blank" rel="noopener noreferrer">
              {{ 'DIGITAL_PASSPORT.CTA_INSURANCE_PROTECTION' | translate }}
            </a>
          </div>
        }
        @if (footerText) {
          <div class="footer-text">
            <quill-view class="notice-rich-text"
              [content]="footerText" format="object"
              theme="snow"></quill-view>
          </div>
        }
      </div>
    </div>
  </main>
}

@if (noWarrantyFound) {
  <main>
    <div class="authenticity-card fade-in text-center pt-8 pr-8 pb-8 pl-8">
      <h2 class="text-xl font-semibold mb-4">{{ 'DIGITAL_PASSPORT.NO_MATCH_TITLE' | translate }}</h2>
      <p class="mb-6">
        {{ 'DIGITAL_PASSPORT.NO_MATCH_MESSAGE' | translate }}
      </p>
      <button id="btn-back-home" class="btn primary-btn mb-6" pButton (click)="backToMainPage()">
        {{ 'DIGITAL_PASSPORT.BTN_BACK_HOME' | translate }}
      </button>
    </div>
  </main>
}

<!-- Passcode -->
<app-digital-card-passcode [visible]="displayPasscodeDialog" [loading]="loading" [errorMessage]="error" (passcodeSubmit)="getWarrantyData($event)"></app-digital-card-passcode>
